module.exports = __webpack_public_path__ + "icon-marker-yellow.svg?5602574f7d602ee64e8c20e2a5a84843";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-marker-yellow.svg
// module id = 35
// module chunks = 0